import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
// import { BsFacebook } from "react-icons/bs";
import Logo from "../../assets/Logo.png";
import "./footer.css";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        <img className="logo" src={Logo} alt="" />
      </a>
      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Skills</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#testimonials">Testimonials</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer__socials">
        <a
          href="https://www.linkedin.com/in/dktechinnovator/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
        <a
          href="https://github.com/folksoul91"
          target="_blank"
          rel="noreferrer"
        >
          <FaGithub />
        </a>
        {/* <a
          href="https://www.facebook.com/dane.kim.5"
          target="_blank"
          rel="noreferrer"
        >
          <BsFacebook />
        </a> */}
      </div>
      <div className="footer__copyright">
        <small className="copyright">&copy; Dane Kim</small>
      </div>
    </footer>
  );
};

export default Footer;
